import { render, staticRenderFns } from "./WebSocket.vue?vue&type=template&id=fdd3cca4&scoped=true"
import script from "./WebSocket.vue?vue&type=script&lang=js"
export * from "./WebSocket.vue?vue&type=script&lang=js"
import style0 from "./WebSocket.vue?vue&type=style&index=0&id=fdd3cca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd3cca4",
  null
  
)

export default component.exports